<app-profile-link
  *ngIf="!isDialog"
  [status]="getStatus(user)"
  [text]="isActiveUser ? ('ACTIVITY_YOU' | translate) : user.displayed_name"
  [userId]="user.user_id"
  [dataTestId]="dataTestId"
  [needComma]="needComma"
  [cssStyles]="isActiveUser ? 'fw-bold' : ''"
  [disabledLink]="isActiveUser"
></app-profile-link>
<app-profile-link
  *ngIf="isDialog"
  [status]="getStatus(user)"
  [text]="isActiveUser ? ('ACTIVITY_YOU' | translate) : user.displayed_name"
  [userId]="user.user_id"
  [dataTestId]="dataTestId"
  [needComma]="needComma"
  [disabledLink]="isActiveUser"
  [cssStyles]="isActiveUser ? 'fw-bold' : ''"
  (submit)="onSubmit()"
></app-profile-link>
